import SlackAuthz from '@/components/app/SlackAuthz';
import CompaniesIndex from '@/components/companies/CompaniesIndex';
import CompaniesShow from '@/components/companies/CompaniesShow';
import Disclaimer from '@/components/contentpages/Disclaimer';
import Terms from '@/components/contentpages/Terms';
// import LoginChangePassword from '@/components/login/ChangePassword';
import ClearToken from '@/components/login/ClearToken';

import FourOhOne from '@/components/errors/401';
import FourOhThree from '@/components/errors/403';
import FourOhFour from '@/components/errors/404';
import Untrapped from '@/components/errors/Untrapped';
import LoginForm from '@/components/login/LoginForm';
import LoginForgotPassword from '@/components/login/PasswordReset';
import ReportCreate from '@/components/reports/ReportCreate';
import ReportsShow from '@/components/reports/ReportShow';
import ReportsIndex from '@/components/reports/ReportsIndex';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: LoginForm,
      meta: {
        forMembers: false,
        forVisitors: true,
        forSuperAdmin: false,
        forIgnitionAdmin: false,
        forClientAdmin: false,
        forClientUser: false,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'loginBackdrop';
        next();
      },
    },
    {
      path: '/forgot-password',
      name: 'loginForgotPassword',
      component: LoginForgotPassword,
      meta: {
        forMembers: true,
        forVisitors: true,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'loginBackdrop';
        next();
      },
    },
    {
      path: '/reset-password/:resetPasswordToken?',
      name: 'LoginForgotPassword',
      component: LoginForgotPassword,
      meta: {
        forMembers: true,
        forVisitors: true,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'loginBackdrop';
        next();
      },
    },
    {
      path: '/cleartoken',
      name: 'clearToken',
      component: ClearToken,
      meta: {
        forMembers: false,
        forVisitors: true,
        forSuperAdmin: false,
        forIgnitionAdmin: false,
        forClientAdmin: false,
        forClientUser: false,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'loginBackdrop';
        next();
      },
    },
    {
      path: '/slack/:nonce',
      name: 'SlackAuthz',
      component: SlackAuthz,
      meta: {
        forMembers: true,
        forVisitors: false,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'adminBackdrop';
        next();
      },
    },
    {
      path: '/reports',
      name: 'ReportsIndex',
      component: ReportsIndex,
      meta: {
        forMembers: true,
        forVisitors: false,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'defaultBackdrop';
        next();
      },
    },
    {
      path: '/reports/create',
      name: 'ReportsCreate',
      component: ReportCreate,
      meta: {
        forMembers: true,
        forVisitors: false,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'defaultBackdrop';
        next();
      },
    },
    {
      path: '/reports/:reportId',
      name: 'ReportsShow',
      component: ReportsShow,
      meta: {
        forMembers: true,
        forVisitors: false,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'defaultBackdrop';
        next();
      },
    },
    {
      path: '/companies',
      name: 'CompaniesIndex',
      component: CompaniesIndex,
      meta: {
        forMembers: true,
        forVisitors: false,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'defaultBackdrop';
        next();
      },
    },
    {
      path: '/companies/:companyId',
      name: 'CompaniesShow',
      component: CompaniesShow,
      meta: {
        forMembers: true,
        forVisitors: false,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'defaultBackdrop';
        next();
      },
    },
    {
      path: '/info/disclaimer',
      name: 'infoDisclaimer',
      component: Disclaimer,
      meta: {
        forMembers: true,
        forVisitors: true,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'defaultBackdrop';
        next();
      },
    },
    {
      path: '/info/terms',
      name: 'infoTerms',
      component: Terms,
      meta: {
        forMembers: true,
        forVisitors: true,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'defaultBackdrop';
        next();
      },
    },
    {
      path: '/error/401',
      component: FourOhOne,
      name: 'FourOhOne',
      meta: {
        forMembers: true,
        forVisitors: true,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'errorBackdrop';
        next();
      },
    },
    {
      path: '/error/403',
      component: FourOhThree,
      name: 'FourOhThree',
      meta: {
        forMembers: true,
        forVisitors: true,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'errorBackdrop';
        next();
      },
    },
    {
      path: '/error/404',
      component: FourOhFour,
      name: 'FourOhFour',
      meta: {
        forMembers: true,
        forVisitors: true,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'errorBackdrop';
        next();
      },
    },
    {
      path: '/error/unknown',
      component: Untrapped,
      name: 'untrapped',
      meta: {
        forMembers: true,
        forVisitors: true,
        forSuperAdmin: true,
        forIgnitionAdmin: true,
        forClientAdmin: true,
        forClientUser: true,
      },
      beforeEnter: (to, from, next) => {
        document.body.className = 'errorBackdrop';
        next();
      },
    },
  ],
});
